
import {Vue, Component, Prop, Watch} from "vue-property-decorator";

@Component({})
export default class SchedulePicker extends Vue {

    get week() {
        return [
            {label: this.$t("day.monday"), name: "monday"},
            {label: this.$t("day.tuesday"), name: "tuesday"},
            {label: this.$t("day.wednesday"), name: "wednesday"},
            {label: this.$t("day.thursday"), name: "thursday"},
            {label: this.$t("day.friday"), name: "friday"},
            {label: this.$t("day.saturday"), name: "saturday"},
            {label: this.$t("day.sunday"), name: "sunday"},
        ];
    }
    @Prop({default: null})
    public companyOpeningHours: any;

    @Prop({default: false})
    public readonly: boolean;

    private hours: any = [];
    private companyHoursCopy: any = {};
    private isLoading: boolean = true;

    @Watch("companyOpeningHours", { immediate: true, deep: true })
    public async handler() {
        this.companyHoursCopy = await JSON.parse(JSON.stringify(this.companyOpeningHours));
        this.fromDataToInput();
    }

    public mutateValue(day, type, hours) {
        if (this.formatNumber(+this.companyHoursCopy[day][type][hours][0]) &&
                this.formatNumber(+this.companyHoursCopy[day][type][hours][1])) {
            const openingHours = [this.formatNumber(+this.companyHoursCopy[day][type][hours][0]),
                this.formatNumber(+this.companyHoursCopy[day][type][hours][1])];
            this.companyHoursCopy[day][type][hours] = [];
            this.companyHoursCopy[day][type][hours] = openingHours;
            this.companyOpeningHours[day][type][hours] = `${this.companyHoursCopy[day][type][hours][0]}:${this.companyHoursCopy[day][type][hours][1]}`;
        }
    }

    private formatNumber(number) {
        return  number.toString().length === 1 ? "0" + number : number;
    }

    private select(elemId: string): void {
        const input: any = document.getElementById(elemId);
        input.focus();
        input.select();
    }

    private fromDataToInput() {
        const keysEntries = ["continuous", "morning", "evening"];
        const valEntries = ["fromHours", "toHours"];

        this.week.forEach((day) => {
            keysEntries.forEach((e) => {
                valEntries.forEach((h) => {
                    if (typeof this.companyHoursCopy[day.name][e][h] === "string") {
                        this.companyHoursCopy[day.name][e][h] = this.companyHoursCopy[day.name][e][h].split(":");
                    }
                });
            });
        });
        this.isLoading = false;
    }
}
